import { makeStyles } from "tss-react/mui"

export const useStyles = makeStyles()(({ spacing }) => ({
  root: {
    display: "flex",
    alignItems: "center",
    gap: spacing(2)
  }
}))
